export let Permission = {
    path: 'permission',
    name: 'permission',
    component: () =>
        import(
            /* webpackChunkName: "permission-manage-page" */ '@/views/back-stage/permission-manage/permission-manage-page.vue'
        ),
};
